import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalButton from './modalButton.component';

interface ModalButtonDeleteProps {
  onClick?: () => void;
  icon?: React.ReactNode;
  disable?: boolean;
}

const ModalButtonDelete: React.FC<ModalButtonDeleteProps> = ( {
  onClick,
  icon,
  disable = false,
} ) => {
  const { t } = useTranslation();

  return (
    <ModalButton
      label={t( 'common:delete' )}
      textColor="text-red-base"
      bgColor="bg-white"
      borderColor="border-white-base"
      hoverBorderColor="hover:border-red-base"
      width="w-fit"
      onClick={onClick}
      icon={icon}
      disable={disable}
    />
  );
};

export default ModalButtonDelete;
